import { toast } from 'react-toastify'

import API from "../../api";
import { queryClient } from "../../react-query"
import { useSellerApp } from "../../../store/service-activation/useSellerApp";
import { formatResponses } from '../../formatResponses/seller-app';
import {formatTemplateData} from "../../formatTemplateData/seller-app";
import {useMerchant} from "../../../store/global/useMerchant";

export class SellerAppModel {
  conectaProAction = useSellerApp.getState().actions

  constructor(props) {
    this.securityCodeModel = props.models.securityCode
  }

  async putSecurityCode(users) {
    const securityCodes = await this.securityCodeModel.fetchCodes(users.filter(u => u.ativo).map(u => u.celular), 'app-crm')
    return formatResponses.formatUsersWithSecurityCode(users, securityCodes)
  }

  async fetchUsers() {
    const storeId = useMerchant.getState().data.merchant.id
    if(!storeId) return

    try {
      const result = await queryClient.ensureQueryData({
        queryKey: ['seller-app', 'users'],
        queryFn: async () => await API.get("seller-app/users")
      })

      const formatedUsers = await this.putSecurityCode(result.data)
      this.conectaProAction.setUsers(formatedUsers)

      return formatedUsers
    } catch (error) {
      console.error(error)
      toast.error('Não foi possível carregar os Usuários do Conecta Pro', { theme: 'colored' })
      return false
    }
  }
  async refreshSecurityCode(userId) {
    try {
      const user = useSellerApp.getState().data.users[userId]
      const result = await this.securityCodeModel.generateCode(user.cellphone, 'app-crm')

      return result
    } catch (error) {
      console.error(error)
      toast.error('Não foi possível cadastrar um novo Usuário', { theme: 'colored' })
      return false
    }
  }
  async createNewUser(data) {
    try {
      const result = await API.post(`seller-app/user`, formatTemplateData.formatUser(data))

      queryClient.setQueryData(['seller-app', 'users'], (oldData) => {
        if (!oldData?.data) return { data: [result.data] }
        return {
          ...oldData,
          data: result.data,
        }
      })

      const formatedUsers = await this.putSecurityCode(result.data)
      this.conectaProAction.setUsers(formatedUsers)

      return formatedUsers
    } catch (error) {
      console.error(error)
      toast.error('Não foi possível cadastrar um novo Usuário', { theme: 'colored' })
      return false
    }
  }
  async updateUser(userId, data) {
    try {
      const userData = useSellerApp.getState().data.users[userId]

      const result = await API.put(`seller-app/user/${userId}`, formatTemplateData.formatUser({...userData, ...data}))

      queryClient.setQueryData(['seller-app', 'users'], (oldData) => {
        if (!oldData?.data) return { data: [result.data] }
        return {
          ...oldData,
          data: result.data,
        }
      })

      const formatedUsers = await this.putSecurityCode(result.data)
      this.conectaProAction.setUsers(formatedUsers)

      return formatedUsers
    } catch (error) {
      console.error(error)
      toast.error('Não foi possível atualizar o Usuário', { theme: 'colored' })
      return false
    }
  }
  async deleteUser(userId) {
    try {
      const result = await API.delete(`seller-app/user/${userId}`)
      queryClient.setQueryData(['seller-app', 'users'], (oldData) => {
        if (!oldData?.data) return { data: [result.data] }
        return {
          ...oldData,
          data: result.data,
        }
      })

      const formatedUsers = await this.putSecurityCode(result.data)
      this.conectaProAction.setUsers(formatedUsers)

      return formatedUsers
    } catch (error) {
      console.error(error)
      toast.error('Não foi possível remover o Usuário', { theme: 'colored' })
      return false
    }
  }
}
